"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSuccessEvaluationDetail = exports.createErrorEvaluationDetail = void 0;
const createErrorEvaluationDetail = (errorKind, def) => ({
    value: def !== null && def !== void 0 ? def : null,
    variationIndex: null,
    reason: { kind: 'ERROR', errorKind },
});
exports.createErrorEvaluationDetail = createErrorEvaluationDetail;
const createSuccessEvaluationDetail = (value, variationIndex, reason) => ({
    value,
    variationIndex: variationIndex !== null && variationIndex !== void 0 ? variationIndex : null,
    reason: reason !== null && reason !== void 0 ? reason : null,
});
exports.createSuccessEvaluationDetail = createSuccessEvaluationDetail;
//# sourceMappingURL=evaluationDetail.js.map